module.exports = __webpack_public_path__ + "static/media/sun-icon.52769d6a.svg";